import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';

const IconButton = ({ icon, title, onClick, className = '' }) => {
    // Initialize state for the current theme
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    // Update theme state when it changes in localStorage
    useEffect(() => {
        const handleThemeChange = () => {
            const currentTheme = document.documentElement.getAttribute('data-theme') || 'light';
            setTheme(currentTheme);
        };

        // Listen for theme changes
        const observer = new MutationObserver(handleThemeChange);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme']
        });

        // Initial theme check
        handleThemeChange();

        return () => observer.disconnect();
    }, []);

    return (
        <button
            onClick={onClick}
            className={`d-flex justify-content-center align-items-center rounded-circle ${className}`}
            style={{
                width: '40px',
                height: '40px',
                backgroundColor: theme === 'dark' ? '#2d2d2d' : '#f8f9fa',
                border: theme === 'dark' ? '1px solid #404040' : '1px solid #e9ecef',
                transition: 'all 0.2s ease',
                color: theme === 'dark' ? '#ffffff' : '#6c757d'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = theme === 'dark' ? '#404040' : '#e9ecef';
                e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = theme === 'dark' ? '#2d2d2d' : '#f8f9fa';
                e.currentTarget.style.transform = 'scale(1)';
            }}
            title={title}
        >
            <Icon 
                icon={icon} 
                style={{ 
                    fontSize: '20px', 
                    color: theme === 'dark' ? '#ffffff' : '#6c757d' 
                }} 
            />
        </button>
    );
};

export default IconButton;
